<div class="PGDatePicker">
        <div class="input-group">
                <input type="text" class="form-control" [attr.id]="fieldId || null" [readonly]="readonly"
                        [(ngModel)]="value" (ngModelChange)="onValueChange()" (change)="change.emit()"
                        ngbDatepicker #datepickerComponent="ngbDatepicker"/>
                <button type="button" class="input-group-text" [disabled]="readonly"
                        (click)="datepickerComponent.toggle()"
                        [attr.aria-label]="'pg-date-picker.a11y.open-calendar' | locTranslate">
                        <i class="fa-regular fa-calendar" aria-hidden="true"></i>
                </button>
        </div>
</div>
